module.exports = __webpack_public_path__ + "img/49.562ca5df.png";